import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { ProductService } from "@app/product/shared/products.service";

export interface ProductQualification {
  id: string;
  abbreviation: string;
}

@Injectable()
export class ProductQualificationsResolver implements Resolve<ProductQualification[]> {
  constructor(private productService: ProductService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ProductQualification[]> {
    return this.productService.getProductQualifications();
  }
}
